// src/analytics/ga4.js
import { logEvent } from 'firebase/analytics';
import i18n from '../i18n';
import { ensureAnalytics } from '../firebase';
import { getPersistedUtm } from './utm';
import { hasGivenConsent } from './consent';

function getDeviceType() {
  if (typeof window === 'undefined') return 'unknown';
  const ua = navigator.userAgent || '';
  if (/Tablet|iPad/i.test(ua)) return 'tablet';
  if (/Mobi|Android|iPhone/i.test(ua)) return 'mobile';
  return 'desktop';
}

function getEnrichment() {
  const utm = getPersistedUtm() || {};
  return {
    language: i18n.language || 'fr',
    device_type: getDeviceType(),
    page_path: typeof window !== 'undefined' ? window.location.pathname : '',
    page_search: typeof window !== 'undefined' ? window.location.search : '',
    ...utm,
  };
}

export async function track(eventName, params = {}) {
  if (typeof window === 'undefined') return;
  const ga = await ensureAnalytics();
  if (!ga) return;
  const enriched = { ...getEnrichment(), ...params };
  try {
    logEvent(ga, eventName, enriched);
  } catch (e) {
    // Failure silencieuse, pas d'erreur user-facing pour un event analytics
  }
}

export { hasGivenConsent };
